import { ForgotPasswordFormValues } from './'

export const validateForgotPasswordForm = (
  values: ForgotPasswordFormValues
) => {
  const errors: Partial<ForgotPasswordFormValues> = {}
  if (!values.email) {
    errors.email = 'Campo richiesto'
  }

  return errors
}
